module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event_diy-e21a8a6ea09e3eef6401c6a934444c32.jpg";